import React, { useEffect, useState } from "react";
import Container from "../Layout/Container";
import ContentBlock from "../Layout/ContentBlock";
import TableColumnRivilePVM25 from "./Items/TableColumnRivilePVM25";
import ContentValidation from "../common/ContentValidation";
import { getShopCategories } from "../../redux/Actions/shopCategoriesAction";

function RivilePVM({ match }) {
  const [Category, setCategory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getShopCategories(true).then((res) => {
      setLoading(false);
      if (res.success) {
        setCategory(res.data);
      } else {
        setCategory([]);
      }
    });
  }, []);

  return (
    <Container
      location={{
        locationName: "Rivile PVM 25",
        locationUrl: match.url,
      }}
    >
      <ContentBlock>
        <div>
          <ContentValidation loader={loading} array={Category}>
            <div className="table-responsive">
              <table className="table table-sm table-hover mt-3">
                <thead>
                  <tr className="text-black">
                    <th>#</th>
                    <th>Pavadinimas</th>
                    <th>PVM25</th>
                  </tr>
                </thead>
                <tbody>
                  {Category.map((item, index, array) => {
                    return (
                      <TableColumnRivilePVM25
                        key={index}
                        index={index}
                        item={item}
                        array={array}
                        setCategory={setCategory}
                        setLoading={setLoading}
                      />
                    );
                  })}
                </tbody>
              </table>
            </div>
          </ContentValidation>
        </div>
      </ContentBlock>
    </Container>
  );
}

export default RivilePVM;
